import React, {useState} from 'react';

import {TermsPageResult} from '../../../../server/routes/main.js'

// // Interface for page data
// interface TermsPageData {
//     html: string;
// }

// Interface for component props
interface TermsProps {
    server: string;
    pageData: unknown;
}

export default function Terms({server, pageData}: TermsProps) {

	let [data, setData] = useState(pageData as TermsPageResult);

	return (
        <>
            <div dangerouslySetInnerHTML={{__html:data.html}} />
        </>
    )
}
